__turbopack_context__.v({
  "text": "TruncatedText-module-scss-module__JpW9FG__text",
});
